<template>
	<div id="industry-detail">
		<div class="content-container">
			<div class="title">{{ item.name }}</div>
			<van-row type="flex" justify="space-between">
				<div>{{ item.publish_time }}</div>
				<div>阅读&nbsp;&nbsp;{{ read_count }}</div>
				<div>
					<van-icon v-if="di_likes" name="like" @click="cancelLike" />
					<van-icon v-else name="like-o" @click="submitLike" />
					{{ likes_count }}
				</div>
			</van-row>
			<div class="content" v-html="item.content"></div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	data() {
		return {
			type: 2,
			activeName: 'content',
			item: null,
			comment_count: 0,
			likes_count: 0,
			di_likes: false,
			read_count: 0,
			isliking: false,
		}
	},

	methods: {
		read() {
			this.vaxios.post(
				`${this.vaxios.host}/open/api/v1/discusses/read`,
				{ id: this.$route.query.id, type: this.type },
				() => {},
				function(err) {
					console.log(err)
				}
			)
		},
		getData() {
			this.item = {
				id: '',
				name: '',
				publish_time: '',
				content: '',
			}
			this.vaxios.get(
				`${this.vaxios.host}/open/api/v1/news/${this.$route.query.id}/detail`,
				{ userId: this.userId },
				(res) => {
					this.item.id = res.data.id
					this.item.name = res.data.name
					this.item.publish_time = this.formatDate(res.data.publish_time)
					this.item.content = res.data.content
					this.comment_count = res.data.comment_count
					this.likes_count = res.data.likes_count
					this.di_likes = res.data.di_likes
					this.read_count = res.data.read_count
				},
				function(err) {
					console.log(err)
				},
				{
					headers: {
						Authorization: 'Bearer ' + this.token,
						'Content-Type': 'application/json',
					},
				}
			)
		},
		// 时间戳
		formatDate(value) {
			var date = new Date(parseInt(value))
			var Y = date.getFullYear() + '-'
			var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
			var D = date.getDate() + ' '
			var h = date.getHours() + ':'
			var m = date.getMinutes()
			return Y + M + D + h + m
		},
		// 富文本的字数
		//html剔除富文本标签，留下纯文本
		getSimpleText(html) {
			var re1 = new RegExp('<.+?>|&nbsp;', 'g') //匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
			var msg = html.replace(re1, '') //执行替换成空字符
			return msg.length
		},
		submitLike() {
			if (this.isliking) return
			this.isliking = true
			this.vaxios.post(
				`${this.vaxios.host}/api/v1/discusses/likes`,
				{ type: this.type, topic_id: this.item.id, user_id: this.user_id },
				(res) => {
					this.di_likes = res.data.di_likes
					this.likes_count = res.data.likes_count
					this.$toast('点赞成功')
					this.isliking = false
				},
				() => {
					console.log('点赞失败')
					this.isliking = false
				},
				{
					headers: {
						Authorization: 'Bearer ' + this.token,
						'Content-Type': 'application/json',
					},
				}
			)
		},
		cancelLike() {
			if (this.isliking) return
			this.isliking = true
			this.vaxios.delete(
				`${this.vaxios.host}/api/v1/discusses/topic/${this.item.id}/likes`,
				{
					type: this.type,
					topic_id: this.item.id,
					user_id: this.user_id,
				},
				(res) => {
					this.di_likes = res.data.di_likes
					this.likes_count = res.data.likes_count
					this.$toast('取消点赞成功')
					this.isliking = false
				},
				() => {
					this.isliking = false
				},
				{
					headers: {
						Authorization: 'Bearer ' + this.token,
						'Content-Type': 'application/json',
					},
				}
			)
		},
	},
	computed: {
		...mapGetters(['token', 'userId', 'communityId']),
	},

	created() {
		this.getData()
	},
	mounted() {
		this.read()
	},
}
</script>

<style scoped>
#industry-detail {
	margin-bottom: 100px;
}

.content-container .title {
	font-size: 1.375rem;
	color: #272727;
	font-weight: bold;
	height: 4.4375rem;
	padding: 0.625rem 0 0 0;
}

.content-container {
	font-size: 0.75rem;
	color: #5c5c5c;
	padding: 0 1rem 0 1rem;
}

.remark {
	font-size: 0.75rem;
	color: #5c5c5c;
}

.content-container .content {
	margin-top: 3.9375rem;
}

.divider {
	margin-top: 6.0625rem;
	width: 100%;
	height: 0.75rem;
	background-color: #f5f5f5;
}

.comment-container .title {
	margin-top: 1rem;
	margin-bottom: 1.59375rem;
	padding: 0 1rem 0 1rem;
	font-size: 1.25rem;
	color: #272727;
	font-weight: bold;
}

.content img {
	display: block;
	width: 100%;
	height: 100%;
}

#like-icon {
	text-align: center;
	font-size: 0.6875rem;
	margin-top: 0.875rem;
}
</style>
